import { ActiveTab, Dialog, Pagination, SingleAction } from "@saleor/types";
import { stringify } from "qs";

export const HotsearchSection = "/hotsearch/";
export const hotsearchListPath = HotsearchSection;

export type HotsearchListUrlDialog = "create" | "update" | "delete";

export type HotsearchListUrlQueryParams = ActiveTab &
  Pagination &
  SingleAction &
  Dialog<HotsearchListUrlDialog>;

export const hotsearchListUrl = (params?: HotsearchListUrlQueryParams) =>
  hotsearchListPath + "?" + stringify(params);
